import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { urlToPattern } from "../urlToPattern";
import logo from "./logo.svg";

export const docSpring = defineConnector({
  identifier: "docSpring",
  name: "DocSpring",
  tagLine: "PDF generation API",
  logo,
  protocol: "http",
  tags: ["documents", "productivity"],
  defaultUrlPattern: ({ baseUrl }) =>
    urlToPattern(baseUrl, "https://(sync\\.)?api(-eu)?\\.docspring\\.com/.*"),
  auth: (app) =>
    basicAuth({
      username: app.secret.tokenId,
      password: app.secret.tokenSecret,
    }),
  steps: [
    {
      title: "Create an API token",
      items: [
        {
          kind: "markdown",
          content:
            "Create an API token in the [DocSpring dashboard](https://app.docspring.com/) and copy both the token ID and token secret. DocSpring authenticates with HTTP Basic auth using `token_id:token_secret`.",
        },
      ],
    },
    {
      title: "Enter your DocSpring details",
      items: [
        {
          kind: "baseUrl",
          label: "API base URL",
          required: true,
          defaultValue: "https://sync.api.docspring.com",
          placeholder: "https://sync.api.docspring.com",
          target: { kind: "configuration", field: "baseUrl" },
          helperText:
            "Use the synchronous US or EU host, or your custom DocSpring host.",
        },
        {
          kind: "input",
          label: "Token ID",
          required: true,
          target: { kind: "secrets", field: "tokenId" },
        },
        {
          kind: "input",
          label: "Token secret",
          required: true,
          target: { kind: "secrets", field: "tokenSecret" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ baseUrl }) =>
      `${baseUrl || "https://sync.api.docspring.com"}/api/v1/authentication`,
  },
});
